export default __webpack_public_path__ + "static/media/marjo.7224f636.svg";